import { primitiveTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const forecastTableControls = style({
  display: "flex",
  alignItems: "center",
  gap: primitiveTokens.sizing["2.5x"]
});

// Fixed, like the two selects beside it: a percentage of a fluid bar
// resizes as neighbours appear, which is what made the row shuffle.
export const planningYearSelect = style({
  display: "flex",
  flex: "0 0 auto",
  width: "9rem",
  minWidth: 0
});
